export default __webpack_public_path__ + "media/img/secondary-3cfb477a97972bc454e01e0dadd2c15b.svg";